import { useState, useEffect } from "react";
import Header from "../../components/header/Header";
import Wheel from "../../components/wheel/Wheel";
import style from "./game.module.css";
import { configAction } from "../../store/config/slice";
import { GameStep } from "../../types/config";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import FooterCo from "../../components/footer/FooterCo";
import Modal from "../../components/modal/Modal";
import ShareBox from "../../components/shareButton/ShareBox";
import { getQueryParamFromUrl } from "../../helpers/url";
import useSelecetCategory from "../../hooks/useSelectCategory";
import SpecialChanceDescriptionModal from "../../Modals/specialChanceDescription/SpecialChanceDescriptionModal";
const GamePage = () => {
  const dispatch = useAppDispatch();
  const params = getQueryParamFromUrl();
  const { selectCategory } = useSelecetCategory(params.category);
  const { isPlayGame } = useAppSelector((state) => state.game);
  const { selectedCategory } = useAppSelector((state) => state.categories);
  const user = useAppSelector((state) => state.login.user.data?.data?.user);

  const handleBack = function () {
    dispatch(configAction.setGameStep(GameStep.CATEGORY));
    window.history.pushState({}, "", "?");
  };
  const [isVisible, setIsVisible] = useState<boolean>(false);
  useEffect(() => {
    if (selectedCategory?.type === "is_special" && user?.special_chance === 0) {
      setIsVisible(true);
    }
    if (!!params.category) {
      selectCategory();
    }
  }, [selectedCategory?.type]);
  return (
    <div className={style.game}>
      <SpecialChanceDescriptionModal
        isModal={isVisible}
        onClose={() => {
          setIsVisible(false);
        }}
      />
      <Modal
        onClose={() => {
          setIsVisible(false);
        }}
        animation="slide-left"
        isModal={isVisible}
        className={`${style["rule-modal"]} mobile`}
        overlayClass={style["rule-modal-overlay"]}
      >
        <div className={style["modal-container"]}>
          <img
            src={`${process.env.PUBLIC_URL}/assets/icon/x.svg`}
            alt=""
            className={style["close-icon"]}
            onClick={() => {
              setIsVisible(false);
            }}
          />
          <img
            src={`${process.env.PUBLIC_URL}/assets/icon/sad-gold-heart.svg`}
            alt=""
            style={{ marginBottom: 20 }}
          />
          <span style={{ color: "#384B70", fontSize: 16, fontWeight: 600 }}>
            شانس ویژه نداری!
          </span>

          <ul className={style["modal-list"]}>
            <li>
              برای چرخوندن گردونه جوایز ویژه بانی‌مد حتما باید "شانس ویژه" داشته
              باشی که فقط از طریق دعوت دوست به بازی به دست میاد.
            </li>
            <li>
              با دعوت از هر دوست غیربانی‌مدی 5 شانس بازی و 5 شانس ویژه دریافت
              می‌کنی.
            </li>
            <li>
              با دعوت از هر دوست بانی‌مدی 2 شانس بازی و 2 شانس ویژه دریافت
              می‌کنی.
            </li>
            <li>
              دوست بانی‌مدی کسیه که قبلا عضو بانی‌مد شده و دوست غیربانی‌مدی کسیه
              که عضو بانی‌مد نبوده و از طریق لینک دعوت تو به خانواده بانی‌مد
              ملحق می‌شه.
            </li>
          </ul>
          <div style={{ width: "100%" }}>
            <ShareBox id={user?.refId!} isSpecial />
          </div>
        </div>
      </Modal>
      <Header
        chance
        title="گردونه بانی‌شانس"
        onBack={handleBack}
        disableBtn={isPlayGame}
      />
      <div className={style.inner}>
        <Wheel />
      </div>
      <FooterCo className="desktop" />
    </div>
  );
};

export default GamePage;
